/**
 * Error estandarizado para respuestas de la API.
 * Garantiza que todos los errores sean instancias de Error con estructura consistente.
 */
export class ApiError extends Error {
  /**
   * @param {string} message   - Mensaje legible para el usuario
   * @param {Array|null} detalles - Detalles de validación [{campo, mensaje}]
   * @param {number|null} status  - Código HTTP de la respuesta
   */
  constructor(message, detalles = null, status = null) {
    super(message);
    this.name = 'ApiError';
    this.detalles = detalles;
    this.status = status;
  }
}

/**
 * Convierte un error de axios en un ApiError con mensaje legible.
 * - Si hay respuesta del servidor, extrae el mensaje y los detalles.
 * - Si no hay respuesta (red caída, timeout), devuelve mensaje genérico de conexión.
 *
 * @param {import('axios').AxiosError} error
 * @returns {ApiError}
 */
export function parseApiError(error) {
  const status = error.response?.status ?? null;
  const data = error.response?.data;

  if (data) {
    let message = data.error || data.mensaje || 'Error desconocido en el servidor';

    if (data.detalles && Array.isArray(data.detalles)) {
      const detalleMsg = data.detalles
        .map(d => `${d.campo}: ${d.mensaje}`)
        .join(', ');
      message = `${message}: ${detalleMsg}`;
    }

    return new ApiError(message, data.detalles ?? null, status);
  }

  // Sin respuesta del servidor (timeout, red caída, CORS, etc.)
  if (!error.response) {
    return new ApiError(
      'No se pudo conectar con el servidor. Verifica tu conexión a internet.',
      null,
      null
    );
  }

  return new ApiError(error.message || 'Error inesperado', null, status);
}
